import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import { SectionName, PaddedContainer } from '../common/styles';

const aspectRatioPortrait = 750 / 992;
const aspectRatioLandscape = 1441 / 708;
const portaitWidth = 100;
const portaitHeight = portaitWidth / aspectRatioPortrait;
const landscapeWidth = 100;
const landscapeHeight = landscapeWidth / aspectRatioLandscape;

const Container = styled.div`
  margin-top: ${props => (props.theme.isMobile ? '0' : '-70px')};
  position: relative;
  top: 0;
  width: 100vw;
  height: ${props => (props.theme.isMobile ? portaitHeight : landscapeHeight)}vw;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const TextContainer = styled(PaddedContainer)`
  ${props => (props.theme.isMobile ? `
    position: relative;
    height: ${portaitHeight}vw;
    margin-top: -${portaitHeight}vw;
    padding-top: 57px;
  ` : `
    position: absolute;
    margin-top: 12vw;
  `)};
  z-index: 150;
`;

const Image = styled(Img)`
  width: 100vw;
  z-index: 100;
  ${props => (!props.theme.isMobile && `
      margin-top: -138px;
  `)};
`;

const Title = styled(SectionName)`
  margin-bottom: ${props => (props.theme.isMobile ? 10 : 20)}px;
`;

const Desc = styled.p`
  margin-top: 20px;
  ${props => !props.theme.isMobile && `
    width: 600px;
  `};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: ${props => (props.theme.isMobile ? 35 : 44)}px;
  line-height: ${props => (props.theme.isMobile ? 46 : 56)}px;
  color: white;
`;

export default function Hero() {
  const {
    hero, heroPortrait, isMobile,
  } = React.useContext(ThemeContext);

  return (
    <Container>
      <Image src={isMobile ? heroPortrait : hero} />
      <TextContainer>
        <Title>our story</Title>
        <Desc>
          From a kitchen table to Australia’s fastest growing investment insights website
        </Desc>
      </TextContainer>
    </Container>
  );
}
